import React, { useMemo } from 'react';

import { Progress } from '@ast/magma/components/progress';

import { WizardStepLocatorsMap } from '@app/common/configurable-wizards';
import { useWizardStepStateContext } from '@app/common/configurable-wizards/WizardStateStateContext';

import styles from './WizardProgressBar.pcss';

export interface WizardProgressBarProps {
  steps: WizardStepLocatorsMap;
  stableName?: string;
  className?: string;
}

const MIN_PROGRESS = 0;
const MAX_PROGRESS = 100;

const getProgressPosition = (allSteps: number, step: number) => {
  const oneStepProgress = MAX_PROGRESS / allSteps;
  const progress = oneStepProgress * step;
  return progress < MAX_PROGRESS ? progress : MAX_PROGRESS;
};

/**
 * Shows the progress of user enrollment wizard process
 */
export const WizardProgressBar: React.FC<WizardProgressBarProps> = React.memo(({
  stableName = 'WizardProgressBar',
  className,
  steps,
}) => {
  const { id, name } = useWizardStepStateContext();

  const progressPosition = useMemo(() => {
    const stepIndex = Array.from(steps).findIndex(([key]) => key === id);
    const stepPosition = (stepIndex <= 0) ? 1 : stepIndex + 1;
    return getProgressPosition(steps.size, stepPosition);
  }, [steps, id]);

  return (
    <div className={className} data-stable-name={stableName}>
      <h1 className={styles.title} data-stable-name={`${stableName}Header`}>
        {name || ''}
      </h1>
      <Progress
        min={MIN_PROGRESS}
        max={MAX_PROGRESS}
        value={progressPosition}
        variant="linear"
      />
    </div>
  );
});

WizardProgressBar.defaultProps = {
  // eslint-disable-next-line i18next/no-literal-string
  stableName: 'WizardProgressBar',
};
